<!-- Gif loading -->
<div *ngIf='loading' style="background-color:rgba(238, 238, 238, 0.507); width:100%; height: 100%; z-index:9999999!important;position:fixed; top:0;  left:0; display: flex; justify-content: center;  align-items: center;" id="progress">
  <img src="assets/img/loading.gif">
</div>

<section class='container mt-3'>
 <div class='row d-flex justify-content-center'> 
  <div class='row d-flex justify-content-center'>
   <h3 class='my-3 ps-lg-0 txtBold'>Información de contacto</h3>
   <div class='row col-md-6 col-lg-3'>
    <div class='col-2 col-lg-3'>
     <img src='../../../assets/img/direccion.png' alt="">
    </div>
    <div class='col-10 col-lg-9 px-0'>
     <p class='txtBold mb-0'>Dirección</p>
     <p>Calle Viriato Fiallo #24, Ensanche Julieta, Distrito Nacional. Santo Domingo, República Dominicana</p>
    </div>
   </div>

   <div class='row col-md-6 col-lg-3'>
    <div class='col-2 col-lg-3'>
     <img src='../../../assets/img/telefono.png' alt="">
    </div>
    <div class='col-10 col-lg-9 px-0'>
     <p class='txtBold mb-0'>Teléfono - WhatsApp</p>
     <p>809-620-2524</p>
    </div>
   </div>
   
   <div class='row col-md-6 col-lg-3 mt-md-3 mt-lg-0'>
    <div class='col-2 px-2 col-lg-3'>
     <img src='../../../assets/img/correo.png' alt="">
    </div>
    <div class='col-10 col-lg-9 px-0'>
     <p class='txtBold mb-0'>Correo electrónico</p>
     <p>info@segurnet.com.do</p>
    </div>
   </div>

   <div class='row col-md-6 col-lg-3 mt-md-3 mt-lg-0'>
    <div class='col-2 px-2 col-lg-3'>
     <img src='../../../assets/img/calendario.png' alt="">
    </div>
    <div class='col-10 col-lg-9 px-0'>
     <p class='txtBold mb-0'>Horario de oficina</p>
     <p>Lunes a Viernes de 8:00 a.m. a 5:30 p.m.<br>Sábados de 8:00 a.m. a 12:30 p.m.</p>
    </div>
   </div>
  </div>
 </div> 
</section>

<!-- Enviar mensaje -->
<section class='container mt-2'>
 
 <div class='row d-flex justify-content-center'>
  <h3 class='mt-3 mb-0 txtBold'>Envíanos un mensaje</h3>
  <form [formGroup]='formContacto' (ngSubmit)='onSubmit()' class='row g-3 needs-validation mt-0' novalidate>
   <div class='col-12'>
     <label for='comentarioCon' class='form-label'>Mensaje:</label>
     <textarea class='form-control' id='comentarioCon' name='comentarioCon' placeholder='Escribir mensaje...' formControlName='comentarioCon' [ngClass]='{"is-invalid": submitted && f.comentarioCon.errors}'></textarea>
     <div *ngIf='submitted && f.comentarioCon.errors' class='invalid-feedback'>
      <div *ngIf='f.comentarioCon.errors.required'>Por favor coloque el mensaje.</div>
    </div>
   </div>  

   <div class='col-md-6'>
    <label for='nombre' class='form-label'>Nombre:</label>
    <input type='text' class='form-control' id='nombre' placeholder='Nombre' name='nombreCon' formControlName='nombreCon' [ngClass]='{"is-invalid": submitted && f.nombreCon.errors}'>
    <div *ngIf='submitted && f.nombreCon.errors' class='invalid-feedback'>
      <div *ngIf='f.nombreCon.errors.required'>Por favor coloque el nombre.</div>
      <div *ngIf='f.nombreCon.errors.pattern'>El nombre debe contener sólo texto. [A-Z]</div>
    </div>
   </div>

   <div class='col-md-6'>
    <label for='correo' class='form-label'>Correo</label>
    <input type='email' class='form-control' id='correo' name='correoCon' placeholder='Correo' formControlName='correoCon' [ngClass]='{ "is-invalid": submitted && f.correoCon.errors}'>
    <div *ngIf='submitted && f.correoCon.errors' class='invalid-feedback'>
      <div *ngIf='f.correoCon.errors.required'>Por favor coloque el correo.</div>
      <div *ngIf='f.correoCon.errors.email'>Debe ser un correo valido.</div>
    </div>
   </div>
   
   <div class='col-12 row px-md-0 d-flex justify-content-end'>
     <div class='m-3 col-md-9 ps-4 pe-lg-3 mx-md-0 mb-lg-0 d-flex justify-content-md-end'>
      <re-captcha (resolved)='resolved($event)' [siteKey]='key'></re-captcha>
     </div>
     <div class='mt-3 col-md-2 col-lg-1 d-flex flex-wrap align-content-center justify-content-end'>
       <button class='btn btn-segurnet' [disabled]='btnShow' type='submit'>Enviar</button>
     </div>
   </div>
 </form>
 </div>

</section>

<!-- Maps -->
<section class='container my-4 mb-lg-5'>
  <div class='row d-flex flex-column justify-content-center'>
    <h5 class='my-3 txtBold text-center'>Visítanos y toma una taza de café con nosotros</h5>
    <p>¿Cómo llegar?</p>
    <iframe src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.2909038292737!2d-69.94785838484074!3d18.47047777552438!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8eaf891590277269%3A0x20770620ef407958!2sSEGURNET!5e0!3m2!1ses!2sdo!4v1612464790329!5m2!1ses!2sdo' width='600' height='450' frameborder='0' style='border:0;' allowfullscreen='' aria-hidden='false' tabindex='0'></iframe>
  </div> 
</section>